export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_USER = "SET_USER";
export const LOGOUT = "LOGOUT";
export const GET_LIST = "GET_LIST";
export const SET_QUERY = "SET_QUERY";
